// configure vuejs organization runtime libs

import Vue from 'vue'
import Router from 'vue-router'
import Vuex from 'vuex'

Vue.config.productionTip = false

Vue.use(Router)
Vue.use(Vuex)
